// ENUM `tipo_equipo_categoria` del modelo Ascensor
// (API-PROAPP/src/models/AscensorModel.ts). Mantener sincronizado.

export const TIPO_EQUIPO_OPTIONS = [
  { value: 'sin_definir', label: 'Sin definir' },
  { value: 'ascensor_pasajeros', label: 'Ascensor pasajeros' },
  { value: 'ascensor_carga', label: 'Ascensor carga' },
  { value: 'escalera_mecanica', label: 'Escalera mecánica' },
  { value: 'funicular', label: 'Funicular' },
  { value: 'rampa_mecanica', label: 'Rampa mecánica' },
  { value: 'montacargas', label: 'Montacargas' },
];

export const TIPO_EQUIPO_LABELS = TIPO_EQUIPO_OPTIONS.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});

export const TIPO_EQUIPO_COLORS = {
  sin_definir: 'default',
  ascensor_pasajeros: 'blue',
  ascensor_carga: 'cyan',
  escalera_mecanica: 'purple',
  funicular: 'geekblue',
  rampa_mecanica: 'gold',
  montacargas: 'volcano',
};
